module.exports = __webpack_public_path__ + "img/back-how-do.c4bc0b36.webp";